export type ReportLocale = 'ro' | 'en';

export const REPORT_LOCALE_STORAGE_KEY = 'posturexe_report_locale';

export const reportLocales: { id: ReportLocale; label: string }[] = [
  { id: 'ro', label: 'RO' },
  { id: 'en', label: 'EN' },
];

export function readStoredReportLocale(): ReportLocale {
  try {
    const v = localStorage.getItem(REPORT_LOCALE_STORAGE_KEY);
    if (v === 'en' || v === 'ro') return v;
  } catch {
    /* ignore */
  }
  return 'ro';
}

export function storeReportLocale(locale: ReportLocale): void {
  try {
    localStorage.setItem(REPORT_LOCALE_STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
}

export type ReportStrings = {
  loading: string;
  errorTitle: string;
  errorExpiredOrMissing: string;
  errorNotFound: string;
  errorLoadFailed: string;
  errorGeneric: string;
  overallScoreTitle: string;
  scoreExcellent: string;
  scoreGood: string;
  scoreNeedsWork: string;
  resultsTitle: string;
  analyses: string;
  framesAnalyzed: (n: number) => string;
  location: string;
  device: string;
  postureAnalysis: string;
  viewFront: string;
  viewSide: string;
  viewBack: string;
  legendOptimal: string;
  legendMinor: string;
  legendNeedsCorrection: string;
  detailedMetrics: string;
  neckAngle: string;
  shoulderAlignment: string;
  spineCurvature: string;
  spineAlignment: string;
  hipAlignment: string;
  shoulderBalance: string;
  recommendations: string;
  reportExpiresOn: string;
  idealRange: string;
  brandSubtitle: string;
};

export const reportStrings: Record<ReportLocale, ReportStrings> = {
  ro: {
    loading: 'Se încarcă analiza posturii...',
    errorTitle: 'Raport Negăsit',
    errorExpiredOrMissing: 'Acest raport poate fi expirat sau nu există.',
    errorNotFound: 'Raportul nu a fost găsit sau a expirat.',
    errorLoadFailed: 'Nu s-a putut încărca raportul.',
    errorGeneric: 'A apărut o eroare.',
    overallScoreTitle: 'Scor General Postură',
    scoreExcellent: 'Postură Excelentă!',
    scoreGood: 'Postură Bună cu Potențial de Îmbunătățire',
    scoreNeedsWork: 'Luați în Considerare Îmbunătățirea Posturii',
    resultsTitle: 'Rezultate Analiză Postură',
    analyses: 'Analize',
    framesAnalyzed: (n) => `${n} cadre analizate`,
    location: 'Locație',
    device: 'Dispozitiv',
    postureAnalysis: 'Analiză Postură',
    viewFront: 'Vedere Frontală',
    viewSide: 'Vedere Laterală',
    viewBack: 'Vedere Posterioară',
    legendOptimal: 'Aliniere Optimă',
    legendMinor: 'Deviere Minoră',
    legendNeedsCorrection: 'Necesită Corecție',
    detailedMetrics: 'Metrici Detaliate',
    neckAngle: 'Unghi Gât',
    shoulderAlignment: 'Aliniere Umeri',
    spineCurvature: 'Curbură Coloană',
    spineAlignment: 'Aliniere Coloană',
    hipAlignment: 'Aliniere Șolduri',
    shoulderBalance: 'Echilibru Umeri',
    recommendations: 'Recomandări',
    reportExpiresOn: 'Acest raport va expira pe',
    idealRange: 'Interval ideal',
    brandSubtitle: 'Analiză postură',
  },
  en: {
    loading: 'Loading posture analysis...',
    errorTitle: 'Report not found',
    errorExpiredOrMissing: 'This report may have expired or does not exist.',
    errorNotFound: 'Report not found or has expired.',
    errorLoadFailed: 'Failed to load report.',
    errorGeneric: 'An error occurred.',
    overallScoreTitle: 'Overall posture score',
    scoreExcellent: 'Excellent posture!',
    scoreGood: 'Good posture with room for improvement',
    scoreNeedsWork: 'Consider improving your posture',
    resultsTitle: 'Posture analysis results',
    analyses: 'Analyses',
    framesAnalyzed: (n) => `${n} frames analyzed`,
    location: 'Location',
    device: 'Device',
    postureAnalysis: 'Posture analysis',
    viewFront: 'Front view',
    viewSide: 'Side view',
    viewBack: 'Rear view',
    legendOptimal: 'Optimal alignment',
    legendMinor: 'Minor deviation',
    legendNeedsCorrection: 'Needs correction',
    detailedMetrics: 'Detailed metrics',
    neckAngle: 'Neck angle',
    shoulderAlignment: 'Shoulder alignment',
    spineCurvature: 'Spinal curvature',
    spineAlignment: 'Spinal alignment',
    hipAlignment: 'Hip alignment',
    shoulderBalance: 'Shoulder balance',
    recommendations: 'Recommendations',
    reportExpiresOn: 'This report expires on',
    idealRange: 'Ideal range',
    brandSubtitle: 'Posture analysis',
  },
};

export function mapFetchErrorToLocale(message: string, t: ReportStrings): string {
  if (message === 'Report not found or has expired') return t.errorNotFound;
  if (message === 'Failed to load report') return t.errorLoadFailed;
  if (message === 'An error occurred') return t.errorGeneric;
  return message;
}
